/*******************************************************************************/
/* Imports
/*******************************************************************************/
import * as t from 'io-ts';
/*******************************************************************************/
/* Argument definitions
/*******************************************************************************/
export const ConditionOperatorV = t.union([t.literal('=='), t.literal('!=')]);
export const ConditionV = t.type({
    field: t.string,
    operator: ConditionOperatorV,
    value: t.union([t.string, t.undefined]),
});
export const ContextArgumentV = t.intersection([
    t.type({
        type: t.literal('context'),
        value: t.string,
        order_key: t.number,
    }),
    t.partial({
        label: t.string,
        chosen: t.union([t.string, t.number]),
        selected: t.array(t.any),
        input_type: t.string,
        preselected_key: t.string,
        label_field: t.string,
        availability_condition: t.array(ConditionV),
        loaded: t.array(t.any),
        allow_create: t.boolean,
        allow_create_label: t.string,
    }),
]);
export const SetArgumentV = t.intersection([
    t.type({
        type: t.literal('set'),
        value: t.union([t.array(t.string), t.array(t.number)]),
        order_key: t.number,
    }),
    t.partial({
        label: t.string,
        chosen: t.union([t.string, t.number]),
        selected: t.array(t.any),
        input_type: t.string,
        preselected_key: t.string,
        label_field: t.string,
        availability_condition: t.array(ConditionV),
        loaded: t.array(t.any),
        allow_create: t.boolean,
        allow_create_label: t.string,
    }),
]);
export const DynamicArgumentV = t.intersection([
    t.type({
        type: t.literal('provided'),
        value: t.union([t.literal('text'), t.literal('time')]),
        order_key: t.number,
    }),
    t.partial({
        label: t.string,
        chosen: t.union([t.string, t.number]),
        selected: t.array(t.any),
        input_type: t.string,
        preselected_key: t.string,
        label_field: t.string,
        availability_condition: t.array(ConditionV),
        loaded: t.array(t.any),
        dateTimeArgumentTypeId: t.number,
        allow_create: t.boolean,
        allow_create_label: t.string,
    }),
]);
export const DependentArgumentV = t.intersection([
    t.type({
        type: t.literal('dependent'),
        value: t.string,
        order_key: t.number,
    }),
    t.partial({
        label: t.string,
        chosen: t.union([t.string, t.number]),
        selected: t.array(t.any),
        input_type: t.string,
        preselected_key: t.string,
        label_field: t.string,
        availability_condition: t.array(ConditionV),
        loaded: t.array(t.any),
        allow_create: t.boolean,
        allow_create_label: t.string,
    }),
]);
export const FunctionArgumentV = t.intersection([
    t.type({
        type: t.literal('function'),
        value: t.string,
        order_key: t.number,
    }),
    t.partial({
        label: t.string,
        chosen: t.union([t.string, t.number]),
        selected: t.array(t.any),
        input_type: t.string,
        preselected_key: t.string,
        label_field: t.string,
        availability_condition: t.array(ConditionV),
        loaded: t.array(t.any),
        allow_create: t.boolean,
        allow_create_label: t.string,
    }),
]);
export const ArgumentTypeV = t.union([
    ContextArgumentV,
    SetArgumentV,
    DynamicArgumentV,
    DependentArgumentV,
    FunctionArgumentV,
]);
export const ArgumentMapV = t.record(t.string, ArgumentTypeV);
export const StepArgumentTypeV = t.intersection([
    t.type({
        userDefinedName: t.string,
        userDefinedValue: t.string,
    }),
    ArgumentTypeV,
]);
//# sourceMappingURL=data:application/json;base64,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